import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { withRouter, RouteComponentProps } from 'react-router'

import { AppState } from "store";
import targetComponent from 'components/student/EntrustStudyUnit';
import studentActions from 'actions/studentActions';
import * as Models from 'models/api';
import { curriculums } from 'utils/constants'

const mapDispatchToProps = (dispatch: Dispatch) => ({ dispatch })

const mapStateToProps = (appState: AppState, ownProps: RouteComponentProps) => {
  return {
    user: appState.session.user!,
    student: appState.student,
    ...ownProps,
  }
}

const mergeProps = (
  stateProps: ReturnType<typeof mapStateToProps>,
  { dispatch }: ReturnType<typeof mapDispatchToProps>) => {

  return {
    ...stateProps,
    getCurriculum: (code: string | undefined) => {
      return curriculums.find(x => x.id === Number(code) ? x.code : null)
    },
    fetchData: (unit_id: number) => {
      dispatch(studentActions.fetchStudyUnit({ unit_id }))
    },

    //設定済み表示のためにのおまかせ学習のデータを取得する
    fetchEntrustStudyData: (curriculum_id: number) => {
      return new Promise<Models.EntrustCurrentRecords>((resolve, reject) => {
        dispatch(studentActions.fetchEntrustStudyRecords({
          curriculum_id,
          promises: { resolve, reject }
        }))
      })
    },
    //グローバルステイトに直接アクセスできるのでいらないかもしれない
    getEntrustStudyState: () => {
      const page = stateProps.student.entrustStudy
      if (page.records) {
        return page.records.entrust_current
      }
    },

    //おまかせ学習の基点を変更する
    updateEntrustBaseTopic: (topic_id: number) => {
      return new Promise<any>((resolve, reject) => {
        dispatch(studentActions.updateEntrustBaseTopic({
          topic_id,
          promises: { resolve, reject }
        }))
      })
    },
    fetchStudyAchievementsLatest: () => {
      return new Promise<Models.StudyAchievementsLatest>((resolve, reject) => {
        dispatch(studentActions.fetchStudyAchievementsLatest(
          { promises: { resolve, reject } }
        ))
      })
    },
  }
}

export type mappedProps = ReturnType<typeof mergeProps>
export default withRouter(connect(mapStateToProps, mapDispatchToProps, mergeProps)(targetComponent))
